export default __webpack_public_path__ + "img/eameaoth.b8e1fb80.svg";